<template>
  <div class="newsItem">
    <div class="infoL">
      <span class="dd">{{ DD }}</span>
      <div class="infoDate">
        <div>{{ YYMM }}</div>
        <div class="clock"></div>
      </div>
    </div>
    <div class="infoC">
      <img :src="newsInfo.cover_pictures" />
    </div>
    <div class="infoR">
      <div class="article">
        <div class="infoTitle">{{ newsInfo.title }}</div>
        <div class="infoCont">{{ newsInfo.summary }}</div>
      </div>
      <div class="moreBtn" />
    </div>
  </div>
</template>

<script>
export default {
  name: "newsItem",
  props: {
    newsInfo: { type: Object, default: () => {} },
  },
  data() {
    return {
      YYMM: "",
      DD: "",
    };
  },
  mounted() {
    if (this.newsInfo.publish_time) {
      this.fmtDate(this.newsInfo.publish_time);
    }
  },
  methods: {
    fmtDate(date) {
      const arr = date.split("T");
      if (arr.length) {
        const dateList = arr[0].split("-");
        this.YYMM = dateList[0] + "年" + dateList[1] + "月";
        this.DD = dateList[2];
      }
    },
  },
};
</script>

<style scoped>
.newsItem {
  display: flex;
  width: 100%;
  justify-content: space-between;
  max-height: 243px;
  cursor: pointer;
  padding: 62px 0;
  border-bottom: 2px solid #e6e6e6;
}
.newsItem .infoL {
  display: flex;
  /* width: 235px; */
  height: 64px;
  padding-right: 38px;
  color: #666666;
  align-items: center;
  box-sizing: border-box;
}
.newsItem .infoL .clock {
  width: 26px;
  height: 26px;
  background: url("../../../common/images/news/clock.png") no-repeat center;
  background-size: contain;
}
.newsItem:hover .infoL {
  color: #398fff;
}
.newsItem:hover .infoL .clock {
  background: url("../../../common/images/news/clock_active.png") no-repeat center;
  background-size: contain;
}

.infoL .dd {
  display: inline-block;
  font-weight: 600;
  font-size: 45px;
  padding-right: 8px;
  border-right: 1px solid #cccccc;
}
.infoL .infoDate {
  display: flex;
  flex-direction: column;
  font-weight: 500;
  padding-left: 8px;
  align-items: flex-start;
  font-size: 25px;
}
.newsItem .infoC {
  width: 35%;
  height: 243px;
  overflow: hidden;
}
.newsItem .infoC img {
  width: 100%;
}
.newsItem .infoC img {
  transform: scale(1);
  transition: all 0.2s;
}
.newsItem:hover .infoC img {
  transform: scale(1.05);
}
.newsItem .infoR {
  flex: 1;
  padding-left: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.newsItem .infoR .infoTitle {
  width: 100%;
  font-weight: 600;
  font-size: 29px;
  color: #1a1a1a;
  text-align: left;

  /* 超出省略号 */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}
.newsItem .infoR .infoCont {
  margin-top: 16px;
  font-weight: 500;
  font-size: 21px;
  color: #4d4d4d;
  text-align: left;

  /* 超出俩行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.newsItem .infoR .moreBtn {
  width: 56px;
  height: 35px;
  background: url("../../../common/images/other/more.png") no-repeat center;
  background-size: contain;
}
.newsItem:hover .infoR .moreBtn {
  background-size: cover;
  background-image: url("../../../common/images/other/more_active.png");
  background-position: center;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/views/news/components/ItemNews.vue